import React from 'react';
import { Navbar, Button } from 'react-bootstrap';
import { FaBars } from 'react-icons/fa';
import './Topbar.scss';

const Topbar = ({ onToggleSidebar = () => {} }) => {
  return (
    <Navbar expand="lg" className="topbar" bg={undefined}>
      <div className="topbar-start">
        <Button
          variant="link"
          className="sidebar-toggle"
          onClick={onToggleSidebar}
          aria-label="Menüyü aç/kapat"
        >
          <FaBars />
        </Button>
      </div>
    </Navbar>
  );
};

export default Topbar;
